<template lang="pug">
.View.View--Explore
  // hack
  v-snackbar(v-model="showGeolocateError" color="error" top :timeout="5000" multi-line)
    div
      b Errore&nbsp;
      br
      span Geolocalizzazione fallita: assicurati di averla attivata nelle impostazioni della privacy del tuo dispositivo.
    v-btn(@click="showGeolocateError=false" dark text) OK
  .d-flex.flex-column.h(style="height:100%")
    .Upper.flex-grow-1
      .Map
        GmapMap(
          :center="map_center"
          :zoom="map_zoom"
          :style="{ width: '100%', height: '100%'}"
          :options="{ disableDefaultUI: true, styles: mapStyles }"
          ref="map"
          @idle="loadPlaces"
          @dragend="saveMapPosition"
        )
            GmapCustomMarker(
              v-for="place, i in filteredPlaces" :key="i"
              :marker="{ lat: place.geo.lat, lng: place.geo.lon }"
              @click.native="$router.push({ name: 'place', params: { place: place.id } })"
            )
              .Marker.elevation-1(:style="{ borderColor: (place.waitingList && place.waitingList.status === 'open') ? categoryNameToColor(place.mainCategory, categories) : 'white' }")
                .d-flex
                  v-icon(medium :color="(place.waitingList && place.waitingList.status === 'open') ? categoryNameToColor(place.mainCategory, categories, 'gray') : 'gray'").mr-2 {{ categoryNameToIcon(place.mainCategory, categories) }}
                  div
                    div.font-weight-medium {{ place.name }}
                    div(v-if="place.waitingList && place.waitingList.status === 'open'")
                      | {{ place.waitingList.currentlyWaiting }} in coda
                    div(v-else)
                      | Lista chiusa
            GmapCustomMarker(v-if="this.pin" :marker="this.pin")
              v-btn.success.elevation-2(icon)
                v-icon(color="white") mdi-account
      .Overlay.pa-3
        .Controls
          .TopBar
            .white.elevation-2.d-block
              v-row.ma-0(align="center")
                div.flex-grow-1
                  gmap-autocomplete(@place_changed="setLocationViaPlace" :options="autocompleteOptions")
                    template(v-slot:input="slotProps")
                      v-text-field.PlaceSearch.mr-3.pt-0.mt-0.elevation-0(
                        solo
                        block
                        placeholder="Cerca..."
                        prepend-inner-icon="mdi-magnify"
                        ref="input"
                        v-on:listeners="slotProps.listeners"
                        v-on:attrs="slotProps.attrs"
                        @focus="hideHelp"
                      )
                v-btn.mr-1(icon v-if="canGeolocate" @click="geolocate()")
                  v-icon mdi-crosshairs-gps
            // .white.d-block.mt-3.elevation-2.pa-3(v-if="showHelpSearch")
              .d-flex.align-start
                v-icon mdi-chevron-up
                .flex-grow-1.px-1.text-center
                  | Inserisci qui sopra la tua posizione o attiva la geolocalizzazione
                v-icon mdi-chevron-up
          .Middle.mt-3(v-if="loadingMap || loadingPlaces")
            .text-center
              .white.d-inline-block.px-5.py-1.elevation-2(style="border-radius: 15px") Geolocalizzazione...
          .BottomBar.text-center
            v-btn.white.elevation-2(rounded @click='showPlacesList=true')
              v-icon(left) mdi-chevron-up
              | Attività
    .Lower
      .pa-2.text-center.white(style="overflow-x: auto;white-space: nowrap;")
        template(v-for="category in categories")
          .d-inline-block.text-center.mr-3(@click='toggleCategory(category.name)' )
            v-btn.white--text(large icon :style="{ 'background-color': selectedCategories.includes(category.name) || selectedCategories.length == 0 ? category.color : 'gray' }")
              v-icon {{ category.icon }}
      .primary.white--text.pa-2(v-if="companyBanner")
        .d-flex.align-center
          .font-weight-medium
            a.clean(href="https://business.openlist.it" target="_blank") Hai un'attività? Scopri come funziona!
          v-spacer
          v-btn(x-small icon @click='hideCompanyBanner')
            v-icon.white--text mdi-close

    // detailed list dialog
    v-dialog(v-model='showPlacesList' scrollable max-width="720px")
      v-card
        v-card-title.pa-3.pb-0
          .font-weight-medium.subtitle-1 Luoghi vicini
          v-spacer
          v-btn(icon @click='showPlacesList=false')
            v-icon mdi-close
        v-card-text.px-0
          .pa-2.text-center(style="overflow-x: auto;white-space: nowrap;")
            template(v-for="category in categories")
              .d-inline-block.text-center.mr-3(@click='toggleCategory(category.name)' )
                v-btn.white--text(
                  large icon
                  :style="{ 'background-color': selectedCategories.includes(category.name) || selectedCategories.length == 0 ? category.color : 'gray' }"
                )
                  v-icon {{ category.icon }}
                div
                  small {{ category.description }}
          v-divider
          .Places
            template(v-if='filteredPlaces.length')
              template(v-for="place in filteredPlaces")
                router-link(:to="{ name: 'place', params: { place: place.id } }" style='text-decoration:none;color:inherit')
                  .Place.pa-3
                    .d-flex.align-center
                      div.mr-2
                        v-img.rounded(:src="place.coverImage" width="3rem" height="3rem")
                      .flex-grow-1.mr-2
                        .font-weight-medium.subtitle-1 {{ place.name }}
                        .font-weight-regular.subtitle-2 {{ categoryNameToPretty(place.mainCategory, categories) }}
                      div.mr-2.text-right(v-if="place.waitingList && place.waitingList.status == 'open'")
                        div.font-weight-bold(:class="waitToColor(place) + '--text'") {{ place.waitingList.currentlyWaiting }} in coda
                        div {{ formatWaitTime(place.waitingList.estimatedLastArrivalDate) }}
                      div.mr-2.text-right(v-else)
                        div Lista chiusa
                v-divider
            template(v-else)
              .text-center.pa-5 Non ci sono luoghi da mostrare che corrispondono alla categoria scelta
            .pt-4.text-center
              v-btn.primary--text(text small outlined @click="requestActivationDialog=true") Non trovi un'attività?
  v-dialog(v-model="requestActivationDialog" max-width="720px")
    v-card
      v-card-title
        | Non trovi un'attività?
        v-spacer
        v-btn(icon @click='requestActivationDialog=false')
          v-icon mdi-close
      ValidationObserver(v-slot="{ invalid, validated, passes }")
        v-card-text
          .text-center Inviaci quanti più dettagli conosci dell’attività che vorresti vedere, ci penseremo noi a contattarla per aggiungerla a OpenList.
          v-form
            v-layout(wrap)
              v-flex(xs12)
                ValidationProvider(name="Nome Attività" rules="required" v-slot="{ errors }")
                  v-text-field(
                    v-model="requestActivationForm.name" required
                    name="nome" type="text"
                    :error-messages="errors"
                    label="Nome Attività *" prepend-inner-icon="mdi-sign-text"
                  )
              v-flex(xs12)
                ValidationProvider(name="Città" rules="required" v-slot="{ errors }")
                  v-text-field(
                    v-model="requestActivationForm.city" required
                    name="citta" type="text"
                    :error-messages="errors"
                    label="Città *" prepend-inner-icon="mdi-map-marker"
                  )
              v-flex(xs12)
                ValidationProvider(name="Indirizzo" v-slot="{ errors }")
                  v-text-field(
                    v-model="requestActivationForm.address"
                    name="indirizzo" type="text"
                    :error-messages="errors"
                    label="Indirizzo" prepend-inner-icon="mdi-map-marker"
                  )
              v-flex(xs12)
                ValidationProvider(name="CAP" v-slot="{ errors }")
                  v-text-field(
                    v-model="requestActivationForm.zipCode"
                    name="cap" type="text"
                    :error-messages="errors"
                    label="CAP" prepend-inner-icon="mdi-map-marker"
                  )
              v-flex(xs12)
                ValidationProvider(name="Provincia" rules="min:2|max:2" v-slot="{ errors }")
                  v-text-field(
                    v-model="requestActivationForm.province" required
                    name="provincia" type="text"
                    :error-messages="errors"
                    label="Provincia" prepend-inner-icon="mdi-map-marker"
                  )
              v-flex(xs12)
                ValidationProvider(name="Telefono" v-slot="{ errors }")
                  v-text-field(
                    v-model="requestActivationForm.phone" required
                    name="telefono" type="text"
                    :error-messages="errors"
                    label="Telefono" prepend-inner-icon="mdi-phone"
                  )
              v-flex(xs12)
                ValidationProvider(name="Email" v-slot="{ errors }")
                  v-text-field(
                    v-model="requestActivationForm.email" required
                    name="email" type="text"
                    :error-messages="errors"
                    label="Email" prepend-inner-icon="mdi-at"
                  )
              v-flex(xs12)
                ValidationProvider(name="Sito Web" v-slot="{ errors }")
                  v-text-field(
                    v-model="requestActivationForm.website" required
                    name="website" type="text"
                    :error-messages="errors"
                    label="Sito Web" prepend-inner-icon="mdi-web"
                  )
        v-card-actions.justify-center
            v-btn.primary(@click="passes(requestActivation)" :loading="requestActivationLoading" :disabled="invalid") Richiedi Attività
  v-snackbar(v-model="requestActivationSnackbar" color="success" top :timeout="3000")
        | Richiesta inviata

</template>

<script>
import Loading from "@/components/Loading";
import Location from "@/api/LocationPublic";
import Category from "@/api/Category";

import GmapCustomMarker from "vue2-gmap-custom-marker";
import GmapCluster from "vue2-google-maps/dist/components/cluster";

import mapStyle from "@/mapStyle";

import {
  waitToColor,
  delay,
  delayToColor,
  formatWaitTime
} from "@/utils/delayUtils";
import {
  categoryNameToIcon,
  categoryNameToPretty,
  categoryNameToColor
} from "@/utils/categoryUtils";
import ErrorMessage from "@/utils/ErrorMessage";

export default {
  name: "Explore",
  components: { Loading, GmapCustomMarker, GmapCluster },

  data: () => ({
    loading: true,
    loadingMap: false,
    loadingPlaces: false,
    map_center: { lat: 42.769406, lng: 12.5679434 },
    map_zoom: 5,
    autocompleteOptions: {
      componentRestrictions: {
        country: ["it"]
      }
    },
    pin: null,
    places: [],
    categories: [],
    showPlacesList: false,
    selectedCategories: [],

    settingCenter: false,

    companyBanner: null,

    mapStyles: mapStyle,

    showHelpSearch: true,
    showGeolocateError: false,
    requestActivationDialog: false,
    requestActivationLoading: false,
    requestActivationForm: {},
    requestActivationSnackbar: false
  }),

  computed: {
    canGeolocate: function() {
      return window.navigator.geolocation;
    },
    filteredPlaces: function() {
      let places = [...this.places];
      if (this.selectedCategories.length) {
        places = places.filter(p =>
          this.selectedCategories.includes(p.mainCategory)
        );
      }
      return places;
    }
  },

  async mounted() {
    this.loading = true;
    this.showHelpSearch = window.localStorage.getItem("showHelpSearch") == null;

    this.$emit("update:title", "Home");
    this.categories = await Category.all();
    this.companyBanner = !window.localStorage.getItem("hide_company_banner");

    let center_lat = window.localStorage.getItem("center_lat");
    let center_lng = window.localStorage.getItem("center_lng");
    let center_zoom = window.localStorage.getItem("center_zoom");
    if (
      center_lat &&
      center_lng &&
      center_zoom &&
      !isNaN(center_lat) &&
      !isNaN(center_lng) &&
      !isNaN(center_zoom)
    ) {
      center_lat = Number(center_lat);
      center_lng = Number(center_lng);
      center_zoom = Number(center_zoom);
    } else {
      center_lat = 42.769406;
      center_lng = 12.5679434;
      center_zoom = 5.25;
    }

    this.$refs.map.$mapPromise.then(async () => {
      this.loading = false;
      this.setCenter(center_lat, center_lng, center_zoom, false);
      //await this.loadPlaces()
      if (this.canGeolocate) {
        try {
          await this.geolocate(true);
        } catch (error) {
          // hack
          this.showGeolocateError = true;
        }
      }
    });
  },

  methods: {
    categoryNameToIcon,
    categoryNameToPretty,
    categoryNameToColor,
    waitToColor,
    delayToColor,
    delay,
    formatWaitTime,

    hideCompanyBanner() {
      window.localStorage.setItem("hide_company_banner", "true");
      this.companyBanner = false;
    },

    toggleCategory(category) {
      if (this.selectedCategories.includes(category)) {
        this.selectedCategories = this.selectedCategories.filter(
          c => c != category
        );
      } else {
        this.selectedCategories.push(category);
      }
    },

    setLocationViaPlace(place) {
      if (!place.geometry) return;
      this.setCenter(
        place.geometry.location.lat(),
        place.geometry.location.lng(),
        16,
        true
      );
      //this.loadPlaces()
    },

    geolocatePromise() {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });
    },

    async geolocate(skipError1 = false) {
      if (navigator.geolocation) {
        let position;
        try {
          this.loadingMap = true;
          position = await this.geolocatePromise();
          this.hideHelp();
          this.setCenter(
            position.coords.latitude,
            position.coords.longitude,
            16,
            true
          );
        } catch (error) {
          if (!skipError1 || error.code != 1) {
            throw new ErrorMessage(
              "Geolocalizzazione fallita: assicurati di averla attivata nelle impostazioni della privacy del tuo dispositivo."
            );
          }
        } finally {
          this.loadingMap = false;
        }

        //this.loadPlaces()
      }
    },

    async setCenter(lat, lng, zoom = 16, pin = true) {
      this.settingCenter = true;
      this.map_center = { lat, lng };
      if (pin) {
        this.pin = { lat, lng };
      } else {
        this.pin = null;
      }
      this.map_zoom = zoom;
      this.$refs.map.$mapObject.setCenter({ lat, lng });
      this.$refs.map.$mapObject.setZoom(zoom);
      window.localStorage.setItem("center_lat", lat);
      window.localStorage.setItem("center_lng", lng);
      window.localStorage.setItem("center_zoom", zoom);
      this.settingCenter = false;
    },

    async saveMapPosition() {
      window.localStorage.setItem(
        "center_lat",
        this.$refs.map.$mapObject.getCenter().lat()
      );
      window.localStorage.setItem(
        "center_lng",
        this.$refs.map.$mapObject.getCenter().lng()
      );
      window.localStorage.setItem(
        "center_zoom",
        this.$refs.map.$mapObject.getZoom()
      );
    },

    distance(lat1, lon1, lat2, lon2) {
      const R = 6371e3; // metres
      const phi1 = (lat1 * Math.PI) / 180; // φ, λ in radians
      const phi2 = (lat2 * Math.PI) / 180;
      const deltaPhi = ((lat2 - lat1) * Math.PI) / 180;
      const deltaLambda = ((lon2 - lon1) * Math.PI) / 180;

      const a =
        Math.sin(deltaPhi / 2) * Math.sin(deltaPhi / 2) +
        Math.cos(phi1) *
          Math.cos(phi2) *
          Math.sin(deltaLambda / 2) *
          Math.sin(deltaLambda / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

      const d = R * c; // in metres
      return d;
    },

    async loadPlaces() {
      if (this.settingCenter) return;
      if (this.loading) return;

      const bounds = this.$refs.map.$mapObject.getBounds();
      let lngMiddle, latMiddle, maxDistanceToBounds;
      if (!bounds) {
        console.log("No bounds");
        latMiddle = this.map_center.lat;
        lngMiddle = this.map_center.lng;
        maxDistanceToBounds = 1000;
      } else {
        const center = bounds.getCenter();
        lngMiddle = center.lng();

        latMiddle = center.lat();

        maxDistanceToBounds = Math.max(
          this.distance(
            latMiddle,
            lngMiddle,
            latMiddle,
            bounds.getNorthEast().lng()
          ),
          this.distance(
            latMiddle,
            lngMiddle,
            bounds.getNorthEast().lat(),
            lngMiddle
          )
        );

        if (maxDistanceToBounds > 15000) {
          console.log("Too far!");
          throw new ErrorMessage(
            "Zoom troppo lontano. Avvicina lo zoom per vedere le attività sulla mappa."
          );
        }
      }

      this.places = await Location.search({
        lat: latMiddle,
        lon: lngMiddle,
        radius: maxDistanceToBounds + 100
      });
    },

    async hideHelp() {
      this.showHelpSearch = false;
      window.localStorage.setItem("showHelpSearch", "false");
    },

    async requestActivation() {
      this.requestActivationLoading = true;
      try {
        await Location.requestActivation(this.requestActivationForm);
      } finally {
        this.requestActivationLoading = false;
      }
      this.requestActivationDialog = false;
      this.requestActivationForm = {};
      this.requestActivationSnackbar = true;
    }
  }
};
</script>

<style lang="scss">
.View.View--Explore {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;

  .Map {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
  }

  .Upper {
    position: relative;
  }
  .Overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    pointer-events: none; // pass click below

    .Controls {
      position: relative;
      width: 100%;
      height: 100%;
      pointer-events: none; // pass click below
      & * {
        pointer-events: all;
      }

      .TopBar {
        @media screen and (min-width: 600px) {
          width: 40rem;
          max-width: 100%;
        }
      }

      .BottomBar {
        position: absolute;
        bottom: 0.5rem;
        width: 100%;
      }
    }
  }
}

.Marker {
  background-color: rgba(255, 255, 255, 1);
  padding: 0.5rem;
  color: black;
  border-radius: 5px;
  cursor: pointer;
  border-style: solid;
  border-width: 2px;
}

.PlaceSearch {
  width: 100%;
  display: inline-block;
  .v-input__slot {
    margin-bottom: 0;
    box-shadow: none !important;
  }
  .v-text-field__details {
    display: none;
  }
}
</style>
